import {
  getDocs,
  query,
  serverTimestamp,
  doc,
  setDoc,
} from "firebase/firestore";

// Creates missing category documents based on existing item category strings.
export async function syncMenuCategoriesFromItems({
  db,
  itemsRef,
  categoriesRef,
}) {
  // Load all items and extract distinct category names.
  const itemSnap = await getDocs(query(itemsRef));
  const nameSet = new Set();
  itemSnap.forEach((itemDoc) => {
    const name = (itemDoc.data().category || "").trim();
    if (name) nameSet.add(name);
  });

  // Load all existing categories once to avoid multiple queries.
  const categoriesSnap = await getDocs(query(categoriesRef));
  const existingByName = new Map();
  let maxSortOrder = 0;
  categoriesSnap.forEach((catDoc) => {
    const data = catDoc.data() || {};
    const key = (data.name || "").trim().toLowerCase();
    if (key) existingByName.set(key, catDoc);
    const sortVal =
      typeof data.sortOrder === "number"
        ? data.sortOrder
        : Number.parseInt(data.sortOrder, 10) || 0;
    if (sortVal > maxSortOrder) maxSortOrder = sortVal;
  });

  let created = 0;
  let skipped = 0;
  let nextSortOrder = maxSortOrder;

  for (const name of nameSet) {
    const key = name.toLowerCase();
    if (existingByName.has(key)) {
      skipped += 1;
      continue;
    }

    nextSortOrder += 1;
    const newDoc = doc(categoriesRef);
    await setDoc(newDoc, {
      name,
      sortOrder: nextSortOrder,
      isActive: true,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
    created += 1;
  }

  return {
    created,
    skipped,
    totalNames: nameSet.size,
  };
}
